import Locales from './locales';

// Label is a dynamic variable that changes according to the user's language
const Label = Locales[navigator.language] ?? Locales['en-US'];

export default Label;
